module.exports = __webpack_public_path__ + "static/media/google_11.6af0aad2.svg";